import { styled } from "@mui/material/styles";
import {Stepper, Step, StepLabel, StepConnector, stepConnectorClasses,} from "@mui/material";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 17,
    left: "calc(-50% + 12px)",
    right: "calc(50% + 12px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
[`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
  backgroundColor: "#EB0000",
},
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#EB0000",
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  zIndex: 1,
  color: "rgb(73, 75, 73)",
  width: 35,
  height: 35,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",

  ...(ownerState.active && {
    backgroundColor: "#EB0000",
    color: "#fff",
    boxShadow: "0 10px 20px 0 rgba(0,0,0,.25)",
  }),

  ...(ownerState.completed && {
    backgroundColor: "#EB0000",
    color: "#fff",
    boxShadow: "0 10px 20px 0 rgba(0,0,0,.25)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ active, completed }}
      className={className}
    >
      {icon}
    </ColorlibStepIconRoot>
  );
}

function SteeperComponent({ stepList, stepNumber }) {
  return (
    <Stepper
      alternativeLabel
      activeStep={stepNumber - 1}
      connector={<ColorlibConnector />}
    >
      {stepList.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={ColorlibStepIcon}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

export default SteeperComponent;